import React, { FC, forwardRef, useImperativeHandle } from 'react';
import { AvatarCard } from './components/avatarCard';
import { t } from '../../utils/helpers';
import Modal from '@ui-kit/components/modal';
import MainButton from '@ui-kit/components/mainButton';
import { useAvatarPicker } from './hooks/useAvatarPicker';
import { SelectedAvatar } from './components/selectedAvatar';
import { Loader } from '@ui-kit/components/loader';

type PropsType = {
  socialAvatar?: string;
  usr: string;
  session: string;
  children?: never;
  userId: string;
};

export const AvatarPicker = forwardRef(({
  usr,
  session,
  socialAvatar,
  userId,
}: PropsType, ref: React.Ref<{handlePickerAvatar: () => void}>) => {
  const [
    { avatarsList, selectedAvatar, showPickerAvatar, avatarImg, isProcessing },
    handleSelectAvatar,
    handlePickerAvatar,
    setNewAvatar,
    handlePickCustomAvatar,
  ] = useAvatarPicker(usr, session, userId, socialAvatar);


  useImperativeHandle(ref, () => ({ handlePickerAvatar }))

  function renderAvatarsList() {
    return avatarsList.map((item, index) => {
      const onClick = () => handleSelectAvatar(index);
      return (
        <AvatarCard
          index={index}
          avatarSelected={selectedAvatar}
          active={selectedAvatar === index}
          onClick={onClick}
          img={avatarsList[index]}
          key={`avatar_${index}`}
        />
      );
    });
  }

  const avatarsJSX = (
    <div className="avatar-picker__content">{renderAvatarsList()}</div>
  );

  const loaderJSX = isProcessing && <Loader height={100} width={100} />;

  function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
    const target = event.target as HTMLInputElement | null;
    if (target && target.files) {
      const file = target.files[0];
      handlePickCustomAvatar(file);
    }
  }

  return (
    <div className="avatar-picker">
      {/*Загруженный аватар*/}
      <SelectedAvatar isProcessing={isProcessing} avatarImg={avatarImg} />

      {/*Показ АватарПикер*/}
      {/* <button
        className="avatar-picker__btn-select-avatar"
        onClick={handlePickerAvatar}
      >
        {t('select_icon')}
      </button> */}

      {/*AvatarPicker*/}
      {showPickerAvatar && (
        <Modal
          title="SELECT YOUR FACE ICON"
          headerBtn
          closeModal={handlePickerAvatar}
        >
          {avatarsJSX}
          {loaderJSX}
          <div className="avatar-picker__buttons">
            <MainButton
              className="avatar-picker__btn--cancel avatar-picker__btn"
              onClick={handlePickerAvatar}
            >
              {t('cancel')}
            </MainButton>
            <MainButton className="avatar-picker__btn" onClick={setNewAvatar}>
              {t('select')}
            </MainButton>
            <div className="avatar-picker__upload">
              <input
                className="avatar-picker__input"
                id="onload-avatar"
                type="file"
                onChange={handleChange}
              />
              <label className="avatar-picker__label" htmlFor="onload-avatar">
                {t('upload')}
              </label>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
});
